<template>
  <el-button
      v-if="$isFunctionShown(funcId)"
      ref="input"
      :disabled="disabled || $isFunctionDisabled(funcId)"
      :icon="icon"
      :plain="plain"
      :size="size"
      :type="type"
      @click="handleClick">
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    plain: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    funcId: {
      type: String,
      default: null
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    },
    // 親からインプット要素をフォーカスするために使われる
    focus: function () {
      this.$refs.input.$el.focus()
    }
  }
}
</script>
